<template>
  <div class="d-flex align-center justify-center py-10">
    <v-card class="pa-8 text-center flex-grow-1 border-card" rounded="xl" max-width="600" width="100%" style="background-color: #f8fafc; border: 1px solid rgba(148, 163, 184, 0.2) !important;">
      <span class="text-overline font-weight-black text-primary tracking-wider mb-4 d-block">
        QUOTE REQUEST RECEIVED
      </span>

      <div class="d-flex justify-center mb-6">
        <div class="d-flex align-center justify-center bg-primary text-white" style="width: 64px; height: 64px; border-radius: 50%; box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);">
          <v-icon icon="mdi-email-check-outline" size="32" />
        </div>
      </div>

      <h2 class="text-h4 font-weight-black text-blue-grey-darken-4 mb-2">Your request is on its way</h2>
      <p class="text-body-2 text-grey-darken-2 font-weight-medium line-height-relaxed px-4 mb-8">
        We have received your customized configuration. A dedicated specialist is putting together your detailed proposal and will reach out to you shortly. Keep an eye on your email and phone.
      </p>

      <!-- Spec Summary Card -->
      <v-card class="pa-4 text-left mb-6 mx-auto w-100 max-w-400" variant="outlined" rounded="lg" style="background: white; border-color: rgba(0,0,0,0.08) !important;">
        <div class="d-flex justify-space-between py-2 border-bottom-thin">
          <span class="text-caption font-weight-bold text-grey-darken-1">Machine</span>
          <span class="text-caption font-weight-black text-blue-grey-darken-4">{{ cart_items.length > 1 ? cart_items.length + ' machines' : copier.instance?.name }}</span>
        </div>
        <div class="d-flex justify-space-between py-2 border-bottom-thin">
          <span class="text-caption font-weight-bold text-grey-darken-1">Acquisition</span>
          <span class="text-caption font-weight-black text-blue-grey-darken-4">
            {{ form.acquisition_type === 'lease' ? form.lease_term + ' month lease' : 'Full purchase' }}
          </span>
        </div>
        <div class="d-flex justify-space-between py-2 border-bottom-thin" v-if="ConfigShowPricing && form.acquisition_type === 'lease' && Number(cartTotalMonthlyPrice || 0) > 0">
          <span class="text-caption font-weight-bold text-grey-darken-1">Estimated Monthly</span>
          <span class="text-caption font-weight-black text-primary">${{ cartTotalMonthlyPrice }}/mo</span>
        </div>
        <div class="d-flex justify-space-between py-2">
          <span class="text-caption font-weight-bold text-grey-darken-1">Status</span>
          <span class="text-caption font-weight-black text-green-darken-3">
            In specialist review
          </span>
        </div>
      </v-card>

      <div class="d-flex justify-center gap-4 mb-6">
        <span class="text-caption font-weight-bold text-green-darken-3">✓ Proposal on the way</span>
        <span class="text-caption font-weight-bold text-grey-darken-1">&bull;</span>
        <span class="text-caption font-weight-bold text-green-darken-3">✓ No obligation</span>
      </div>

      <div class="text-caption text-grey-darken-1 font-weight-bold mb-6">
        No payment is due today. We will contact you shortly to review options and confirm your delivery details.
      </div>

      <v-btn
        :color="ConfigElementsColor"
        block
        rounded="lg"
        size="large"
        class="text-none font-weight-bold mb-2"
        @click="$emit('close')"
      >
        Done
      </v-btn>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

defineProps<{
  copier: {
    instance: any
    datasets: any[]
    accessories: any[]
  }
  cartTotalMonthlyPrice?: number
  preapprovalStatus?: string
}>()

defineEmits<{
  (e: 'close'): void
}>()

const store = useGlobalsStore()
const { form, cart_items, ConfigElementsColor, ConfigShowPricing } = storeToRefs(store)
</script>

<style scoped lang="scss">
.border-card {
  border: 1px solid rgba(148, 163, 184, 0.2) !important;
}
.border-bottom-thin {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.max-w-400 {
  max-width: 440px;
}
</style>
